module.exports = __webpack_public_path__ + "static/img/h10.51b3115.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hor/h10.jpg
// module id = jtIR
// module chunks = 1